import { Navigate } from 'react-router-dom';

import { ContactPage } from '../../pages/contact/ContactPage';
import { marketingSiteUrl } from '../../utils/marketingSiteUrl';
import { isMarketingHost } from '../../utils/siteHost';

/** Contact form lives on the marketing site only. */
export function MarketingContactRoute() {
  if (isMarketingHost()) {
    return <ContactPage />;
  }
  return <Navigate to={marketingSiteUrl('/contact')} replace />;
}
